// extracted by mini-css-extract-plugin
export default {"link":"CZUQ16dx0QyEqgn+Kz07wA=="};